import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { userDataSelector } from '../../Redux/login/loginReducer';

export const useContractSubscriptions = () => {
  const userData = useSelector(userDataSelector);

  const contractSubscriptions = useMemo(() => {
    const userSubscriptions = userData?.contractUserSetting?.userSubscriptions?.filter(
      (item) => item?.isActive !== false
    );
    return {
      clm: userSubscriptions ? userSubscriptions?.find((item) => item?.service === 'CLM') : null,
      docChat: userSubscriptions
        ? userSubscriptions?.find((item) => item?.service === 'DOCCHAT')
        : null,
      docCompare: userSubscriptions
        ? userSubscriptions?.find((item) => item?.service === 'DOCCOMPARE')
        : null,
    };
  }, [userData]);

  return contractSubscriptions;
};
